import React from "react";

import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

const DatePicker = ({ selectedDate, setSelectedDate }) => {
  return (
    <DayPicker
      mode="single"
      selected={selectedDate}
      onSelect={(day) => setSelectedDate(day)}
      fromDate={new Date()}
    />
  );
};

export default DatePicker;
